import { use, useState } from "react";

import { ReportTasks } from "../components/report/tasks";
import { Select } from "../components/select";
import { useProjects } from "../queries/project";
import { useLocale } from "../stores/locale";

export function Report() {
  const { data: projects, isLoading: isProjectsLoading } = useProjects();
  const t = useLocale((state) => state.locale);

  const [selectedProject, setSelectedProject] = useState<string>(
    projects?.[0] ?? "",
  );

  return (
    <div>
      {isProjectsLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          <Select
            label={t.time.project}
            options={
              projects?.map((project) => ({
                label: project,
                value: project,
              })) || []
            }
            placeholder={t.time.project}
            value={selectedProject}
            onChange={setSelectedProject}
          />
          <ReportTasks project={selectedProject} />
        </>
      )}
    </div>
  );
}
